import firebase from "firebase/app";

import React from "react";
import { Outlet, useOutletContext } from "react-router-dom";

import getDistributionChannelsQuery from "astrid-firestore/src/api/distribution/getDistributionChannelsQuery";
import { useLoadingValues } from "astrid-firestore/src/hooks";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";
import useDocumentData from "astrid-firestore/src/hooks/useDocumentData";

import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import useArticles from "../../../articles/hooks/useArticles";
import featureFlags from "../../../authorization/constants/featureFlags";
import useWorks from "../../../works/hooks/useWorks";

import SerieView from "../../views/SerieView/SerieView";

export default function Serie() {
	const { organization, serie } = useOutletContext();

	const [[publisher, articles, works, channels], loading, error] = useLoadingValues(
		useDocumentData(serie.publisher.ref),
		useArticles({ serie }),
		useWorks({ serie }),
		useCollectionData(getDistributionChannelsQuery(firebase)),
	);

	const context = {
		articles,
		channels,
		organization,
		publisher,
		serie,
		works,
	};

	return (
		<LoadingContext data={serie} loading={loading} error={error} featureFlag={featureFlags.FLATTENING}>
			<SerieView {...context}>
				<Outlet context={context} />
			</SerieView>
		</LoadingContext>
	);
}
